import { ResetPassword } from "@/components/auth/ResetPassword";

const ResetPasswordPage = () => {
  return <ResetPassword />;
};

export { ResetPasswordPage };
